"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 *  Wraps portion of entities usually found by filter.
 *  Provides information about that portion.
 */


var PortionDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PortionDTO, _DomainObject_1$Domai);

  /**
   *
   * @param limit
   * @param offset
   * @param exceeded
   * @param result
   * @param dataType Should be className of entity T ( eg WindowItem.name )
   */
  function PortionDTO(limit, offset, exceeded, result, dataType) {
    var _this;

    _classCallCheck(this, PortionDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PortionDTO).call(this));
    _this.limit = limit;
    _this.offset = offset;
    _this.exceeded = exceeded;
    _this.result = result;
    _this.dataType = dataType;
    return _this;
  }

  return PortionDTO;
}(DomainObject_1.DomainObject);

exports.PortionDTO = PortionDTO;